import type { PropType } from 'vue';

export type ClearableType = boolean | 'out';

export const defaultClearableType: ClearableType = false;

export const clearableValidator = (value: unknown) => value === undefined || typeof value === 'boolean' || value === 'out';

export const clearableProp = {
    type: [Boolean, String] as PropType<ClearableType>,
    default: defaultClearableType,
    required: false,
    validator: clearableValidator,
};
